import type { Overage } from "./metrics.types";

/**
 * Display formatting for the Metrics Dashboard. Kept out of `partnerMetrics.ts`
 * so that module stays "pure math" and this one stays "how a number reads".
 */

/** Compact currency: 2_115_000 -> "$2.1M", 410_000 -> "$410K", 850 -> "$850". */
export function formatCompactCurrency(value: number): string {
  if (value >= 1_000_000) return `$${Math.round(value / 100_000) / 10}M`;
  if (value >= 1_000) return `$${Math.round(value / 1_000)}K`;
  return `$${Math.round(value)}`;
}

/** Overage summary for the table cell, e.g. "+35 Ad Hoc" or "—". */
export function overageLabel(overage: Overage): string {
  if (!overage.isBreached) return "—";
  const parts: string[] = [];
  if (overage.savedOver > 0) parts.push(`+${overage.savedOver} Saved`);
  if (overage.adhocOver > 0) parts.push(`+${overage.adhocOver} Ad Hoc`);
  return parts.join(", ");
}
